import { AutogenLayoutDivisionCode } from "./autogen/AutogenLayoutDivisionCode";
import { DuplicateId } from "@mcleod/dispatch";

export class DivisionCode extends AutogenLayoutDivisionCode {
    onLoad() {
        DuplicateId.configureIdTextbox(this.textboxId, {
            tableName: "division",
            screenName: "Division Code",
            navigateToUrl: "lme/settlement/DivisionCode?mode=update&key="
        });
    }
}
